import { ASSET_CAT_API, async_func_data, CASH_API, CREDIT_API, EXP_API, getScreenFromApi, get_api_responseContainer, handleResponse, INCOME_API, NET_API, } from "../Utils/helperfunctions";
import { ERROR_OCCURED, SUCCESS_CODE, } from "./../../constants/return_code_constants";
import { getFormattedValue, roundNum } from "./../../functions/formatData";
import { resolveObjectPath } from "./../../functions/utils";
import { GENERAL_SET_GRAPH_DATA, GENERAL_SET_PIE_DATA, GENERAL_TRASACTION, PIE_DATA_EMPTY, RESET_PORTFOLIO, } from "./types";
import { color_pallete } from "../../styles";
import { isAdvisorSelector, currentClientSelector } from "../user/selectors";
const convert_to_pie_helper = (data, property) => {
    const pie_data = [];
    const accord_data = [];
    let total = 0;
    let flag = false;
    data.map((item) => {
        if (property !== undefined) {
            if (item[property]) {
                total += +item[property];
            }
        }
    });
    data.map((item, idx) => {
        if (property !== undefined) {
            const should_add = item[property] !== null;
            if (should_add) {
                const per = +roundNum((+item[property] / total) * 100, 0, 2, true);
                // const color = getRandomColor().slice(1, 7);
                const color = color_pallete[idx];
                accord_data.push({
                    ...item,
                    per,
                    color,
                    selected: false,
                });
                if (+item[property] / total) {
                    pie_data.push({
                        x: getFormattedValue(+item[property] / 1000, "money"),
                        y: Math.abs(+item[property]),
                        selected: flag,
                        per,
                        color,
                        ...item,
                    });
                }
                flag = false;
            }
        }
    });
    if (accord_data.length && pie_data.length) {
        return {
            accord_data,
            pie_data,
            total,
        };
    }
    return null;
};
const convert_to_graph_helper = (data, property1, property2, property3, totalProp, dateProp, 
// Temp
api) => {
    const graph_data = [];
    const accord_data = resolveObjectPath(property3, data);
    let total = resolveObjectPath(totalProp, data);
    if (api === "cashflow") {
        resolveObjectPath(property2, data)?.map((item) => {
            let exp = 0;
            let inc = 0;
            item.transactionData.map((itm) => {
                if (itm.categoryType === "EXPENSE") {
                    exp += +itm.amount;
                }
                else {
                    inc += +itm.amount;
                }
            });
            graph_data.push({
                x: item[dateProp || "date"],
                y: -exp,
                year: item.currentYear,
            });
            graph_data.push({
                x: item[dateProp || "date"],
                y: inc,
                year: item.currentYear,
            });
        });
    }
    else {
        const series = resolveObjectPath(property2, data);
        series?.map((item) => {
            if (property1 !== undefined) {
                graph_data.push({
                    x: item.date,
                    y: +item[property1],
                });
            }
        });
        // If total is missing, prefer latest series value instead of summing
        if (total === undefined ||
            total === null ||
            total === "" ||
            isNaN(+total)) {
            if (Array.isArray(series) && series.length && property1 !== undefined) {
                total = +series[series.length - 1][property1];
            }
        }
    }
    return { graph_data, total: total, accord_data: accord_data || [] };
};
const api_helper = async (api, params, successActionType, [dispatch, getState], method) => {
    const { api_params: { url }, pie_args, responseContainer, payloadCont, } = get_api_responseContainer(api);
    const isAdvisor = isAdvisorSelector(getState());
    const userId = isAdvisor
        ? currentClientSelector(getState())?.uuid
        : getState().userReducer.userData?.uuid;
    const paramsOb = { ...params, userId };
    const { responseData, errorCode } = await async_func_data(url, paramsOb, [getState, dispatch], method);
    let payload;
    let successAction;
    const screen = getScreenFromApi(api);
    const resData = resolveObjectPath(responseContainer, responseData);
    // Temporary just for networth data, due to structure of it (not in array format so resData.length was failing)
    // We have to pass separate payloadCont to it to verify the data exist
    // Solution - change the networth data strcture to get rid of payload container maybe?
    // Or keep this check as is.
    const payloadCheck = payloadCont
        ? resolveObjectPath(payloadCont, responseData).length
        : resData.length;
    if (errorCode === SUCCESS_CODE) {
        payload = payloadCheck
            ? successActionType === GENERAL_SET_GRAPH_DATA
                ? convert_to_graph_helper(resData, ...pie_args, api)
                : convert_to_pie_helper(resData, ...pie_args)
            : null;
        if (!payload) {
            dispatch(pieDataEmpty({ api, screen }));
            return SUCCESS_CODE;
        }
        if (successActionType === "GENERAL_SET_PIE_DATA") {
            // eslint-disable-next-line prettier/prettier
            const { pie_data, accord_data, total } = payload;
            successAction = {
                type: successActionType,
                payload: {
                    pie_data,
                    accord_data,
                    total,
                    screen,
                    api_name: api,
                },
            };
        }
        else {
            const { accord_data, total, graph_data } = payload;
            successAction = {
                type: successActionType,
                payload: {
                    accord_data,
                    total,
                    graph_data,
                    screen,
                    api_name: api,
                },
            };
        }
        const responseCode = await handleResponse(errorCode, dispatch, successAction);
        return responseCode;
    }
    const responseCode = await handleResponse(errorCode, dispatch, null);
    return responseCode;
};
export const get_transactions_helper = async (api, params, [dispatch, getState], method) => {
    const { transactionApiParams } = get_api_responseContainer(api);
    if (transactionApiParams !== undefined) {
        const { url, otherParams } = transactionApiParams;
        if (otherParams) {
            const { container } = otherParams;
            const isAdvisor = isAdvisorSelector(getState());
            const userId = isAdvisor
                ? currentClientSelector(getState())?.uuid
                : getState().userReducer.userData?.uuid;
            const { responseData, errorCode } = await async_func_data(url, { ...params, userId }, [getState, dispatch], method);
            let successAction;
            const transaction = resolveObjectPath(container, responseData);
            if (errorCode === SUCCESS_CODE) {
                successAction = {
                    type: GENERAL_TRASACTION,
                    payload: {
                        trans_data: transaction || [],
                        screen: getScreenFromApi(api),
                        api_name: api,
                    },
                };
                const responseCode = await handleResponse(errorCode, dispatch, successAction);
                return responseCode;
            }
            const responseCode = await handleResponse(errorCode, dispatch, null);
            return responseCode;
        }
    }
    return ERROR_OCCURED;
};
/** NODE API CALLS  *** */
// GET NET WORTH
export const get_networth = () => async (...thunkArgs) => api_helper(NET_API, null, GENERAL_SET_GRAPH_DATA, thunkArgs, "get");
// GET INCOME
export const get_income = (params) => async (...thunkArgs) => api_helper(INCOME_API, params, GENERAL_SET_PIE_DATA, thunkArgs, "get");
// EXTRACT TRANSACTIONS FROM DATA -> later convert to api call
export const get_income_transactions = (params) => async (...thunkArgs) => get_transactions_helper(INCOME_API, params, thunkArgs, "get");
// GET EXPENSE
export const get_expense = (params) => async (...thunkArgs) => api_helper(EXP_API, params, GENERAL_SET_PIE_DATA, thunkArgs, "get");
// EXTRACT TRANSACTIONS FROM DATA -> later convert to api call
export const get_expense_transactions = (params) => async (...thunkArgs) => get_transactions_helper(EXP_API, params, thunkArgs, "get");
// GET EXPENSE
export const get_cashflow = (params) => async (...thunkArgs) => api_helper(CASH_API, params, GENERAL_SET_GRAPH_DATA, thunkArgs, "get");
// GET ASSETS
export const get_assets_cat = () => async (...thunkArgs) => api_helper(ASSET_CAT_API, null, GENERAL_SET_PIE_DATA, thunkArgs, "get");
export const get_liab_credit = () => async (...thunkArgs) => api_helper(CREDIT_API, null, GENERAL_SET_PIE_DATA, thunkArgs, "get");
// Actions
export const pieDataEmpty = (payload) => ({
    type: PIE_DATA_EMPTY,
    payload,
});
export const resetPortfolio = () => ({
    type: RESET_PORTFOLIO,
});
